<template>
  <div class="people_wrap dialog-app-panel" :class="showPeoplePanel ? 'dialog-show' : ''">
    <appPanel class="app-panel" :width="770" :isExpand="showPeoplePanel" title="选择人员" @cancel="handleClosePeoplePanel">
      <div class="choose-people">
        <div v-for="(item, index) in checkPeople" class="people" :key="index">
          <el-tag size="small" @close="handleCloseTag(item)" closable>{{ item.name }}</el-tag>
        </div>
      </div>
      <ioc-table ref="multipleTable" :data="tableData" :option="constData.peopleSelectTable" :page="constData.page"
        @selection-change="handleSelectionChange" @search-change="handleSearchChange" @search-reset="handleSearchReset">
        <template slot="img" slot-scope="scope">
          <img v-if="scope.row.facePicFileCode" :src="getImgPath(scope.row.facePicFileCode)"
            @click="showViewer(getImgPath(scope.row.facePicFileCode), $event)"
            onerror="" style="height: 40px; width: 50px; cursor: pointer;" />
        </template>
      </ioc-table>

      <div slot="footer" class="dialog-footer" style="margin-bottom: 18px;">
        <el-button @click="handleClosePeoplePanel" type="info" :loading="subLoading">
          {{ subLoading ? "提交中" : "取消" }}
        </el-button>
        <el-button type="primary" :loading="subLoading" @click="handleSavePeoplePanel">
          {{ subLoading ? "提交中" : "确定" }}
        </el-button>
      </div>
    </appPanel>
  </div>
</template>

<script>
import { api } from "../api/index";
import appPanel from "@src/components/business/app-panel/index";
import utils from "@src/common/utils";
import { Bus } from "$utils";
import { peopleSelectTable } from "../config/peopleSelectTable";
export default {
  components: {
    appPanel,
  },
  props: {
    // groupCode: {
    //   type: String,
    //   default: "",
    // },
    showPeoplePanel: {
      type: Boolean,
      default: false,
    },
    selectGroup: {
      type: String,
      default: "",
    },
  },
  watch: {
    showPeoplePanel: {
      handler(val) {
        if (val) {
          // this.constData.page.pageNum = 1;
          // this.constData.page.pageSize =
          // utils.Cache.get("CURRENT_PAGESIZE") || 10;
          this.getPeople();
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      constData: {
        peopleSelectTable: peopleSelectTable(true, true),
        // page: {
        //   pageNum: 1,
        //   total: 0,
        //   pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
        // },
        searchForm: {},
      },
      tableData: [],
      checkPeople: [],
      subLoading: false,
    };
  },
  created() { },
  mounted() { },
  methods: {
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    showViewer(src, e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    handleClosePeoplePanel(type = false) {
      this.checkPeople = [];
      this.$emit("handleClosePeoplePanel", type);
    },
    getPeople() {
      let params = {
        // ...this.constData.page,
        ...this.constData.searchForm,
        // thirdRightGroupCode: this.groupCode,
      };
      this.$fetch(api.peopleSelect.getPeople, params).then((res) => {
        if (!res.success) {
          this.$$message.error(res.msgContent || "获取数据失败");
          return;
        }
        this.tableData = res.returnObj;
        // console.log(this.tableData);
        // this.constData.page.total = res.returnObj.total;
      });
    },
    handleSavePeoplePanel() {
      if (!this.checkPeople.length) {
        this.$message.warning("请选择人员");
        return;
      }
      let params = {
        personnelCodes: this.checkPeople.map((el) => {
          return el.personnelCode;
        }),
        personnelGroupCode: this.selectGroup,
      };
      this.subLoading = true;
      this.$fetch(api.peopleSelect.addGroupPersonnel, params).then((res) => {
        this.subLoading = false;
        if (res.success) {
          this.$message.success("操作成功");
          this.handleClosePeoplePanel(true);
        } else {
          this.$message.error(res.msgContent || "添加失败");
        }
        //
      });
    },
    handleSearchChange(param) {
      // this.constData.page.pageNum = 1;
      this.constData.searchForm = Object.assign({}, param);
      this.getPeople();
    },
    // 条件重置
    handleSearchReset() {
      // this.constData.page.pageNum = 1;
      // this.constData.page.pageSize = 10;
      this.constData.searchForm = {};
      this.getPeople();
    },
    // 分页查询
    handleCurrentChange(val) {
      // this.constData.page.pageNum = val;
      this.getPeople();
    },
    // 条数查询
    handleSizeChange(val) {
      // this.constData.page.pageNum = 1;
      // this.constData.page.pageSize = val;
      this.getPeople();
    },
    // 多选
    handleSelectionChange(row) {
      this.checkPeople = [...row];
    },
    handleCloseTag(item) {
      this.$refs.multipleTable.$refs.multipleTable.toggleRowSelection(
        item,
        false
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.people_wrap {
  width: 100%;
  height: 100%;

  .choose-people {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 6px;

    .people {
      margin: 0px 5px 5px;
    }
  }
}
</style>